import template from './product-related.template.html';
import controller from './product-related.controller';
import './product-related.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/product/product-related/product-related.component.js